import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const ResizeBar = styled.div`
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 5px;
  border-right: 1px solid ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
  cursor: col-resize;
`;

export const ResizeColumnWidthStyled = styled.div`
  position: relative;
  z-index: 10;

  &[data-is-resizing='true'],
  &:hover {
    &:not([data-is-resizing-disabled='true']) {
      ${ResizeBar} {
        display: block;
      }
    }
  }
`;
